module.exports = __webpack_public_path__ + "static/media/imgAdd.d201d84b.svg";